import React, { useState, useEffect } from 'react'
import { Tooltip } from '@bedrock/components'
import { isPromise } from '@bedrock/components/lib/utils'
import { HelpCircle } from '@bedrock/icons-react'
import classNames from 'classnames/bind'
import styles from './index.less'

const cx = classNames.bind(styles)

type ShowLabelProps = {
  text: string | number | React.ReactNode
  labelTip?: string | number | React.ReactNode | Promise<string | number | React.ReactNode>
  colon?: boolean
} & React.HTMLAttributes<HTMLSpanElement>

export default function ShowLabel({ text, labelTip, colon, className, ...props }: ShowLabelProps) {
  const [title, setTitle] = useState<string | number | React.ReactNode>('')

  useEffect(() => {
    if (isPromise(labelTip)) {
      labelTip
        .then(v => setTitle(v))
        .catch((e) => console.log('error', e))
      return
    }
    setTitle(labelTip);
  }, [labelTip])

  return <span className={cx('show-label', className)} {...props}>
    {text}
    {title && (
      <Tooltip title={title}>
        <HelpCircle size={14} />
      </Tooltip>
    )}
    {colon && '：'}
  </span>
}
